import { Component, OnInit } from '@angular/core';
import { AdminsDashboardService } from '../../../admin-dashboard/service/admins-dashboard.service';
import { LoginResponse } from '../../../authentication/models/login-response.dto';
import { AssessorsDashboardService } from '../../service/assessors-dashboard.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-assessors-dashboard',
  templateUrl: './assessors-dashboard.component.html',
  styleUrls: ['./assessors-dashboard.component.scss'],
})
export class AssessorsDashboardComponent implements OnInit {
  dashboardDetails: any;
  blobkUnblockData: any;

  total: number;
  size: number = 10;
  page: number = 1;

  constructor(
    private assessorsDashboardService: AssessorsDashboardService,
    private router: Router
  ) {}

  ngOnInit(): void {
    let currentUserInfo: LoginResponse = JSON.parse(
      localStorage.getItem('currentUserInfo') ?? '{}'
    );

    if (currentUserInfo?.id != null) {
      this.getDashboardDetails(currentUserInfo?.id);
    }

    this.getBlockUnblockDetails();
  }

  getDashboardDetails(userId: any) {
    this.assessorsDashboardService
      .getAssessorsDashboardDetails(userId)
      .subscribe({
        next: (res: any) => {
          this.dashboardDetails = res.data;
        },
      });
  }

  applyNew(): void {
    this.router.navigate(['/home/assessor-pool/apply-assessor-pool']);
  }

  getBlockUnblockDetails() {
    this.assessorsDashboardService.readBlockUnblockData().subscribe({
      next: (res: any) => {
        const filtered = res.data
          .filter((item: any) => {
            return (
              item.unblockDatetime &&
              new Date(item.unblockDatetime).getTime() > Date.now()
            );
          })
          .map((item: any) => ({
            ...item,
            displayTime: this.formatTime(item.unblockDatetime),
          }));

        this.blobkUnblockData = filtered;
      },
    });
  }

  formatTime(unblockDatetime: string): string {
    const now = new Date().getTime();
    const unblockTime = new Date(unblockDatetime).getTime();
    const diff = unblockTime - now;

    if (diff <= 0) return 'Expired'; // still useful for safeguard, even if filtered

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts = [];
    if (days) parts.push(`${days} Day${days > 1 ? 's' : ''}`);
    if (hours) parts.push(`${hours} Hour${hours > 1 ? 's' : ''}`);
    if (minutes) parts.push(`${minutes} Minute${minutes > 1 ? 's' : ''}`);
    if (seconds) parts.push(`${seconds} Second${seconds > 1 ? 's' : ''}`);

    return parts.join(', ');
  }
}
